/*User Project Education Start*/
export const SET_EDUCATION = 'SET_EDUCATION';
export const CREATE_EDUCATION = "CREATE_EDUCATION";
export const RETRIEVE_EDUCATIONS = "RETRIEVE_EDUCATIONS";
export const UPDATE_EDUCATION = "UPDATE_EDUCATION";
export const DELETE_EDUCATION = "DELETE_EDUCATION";
export const GET_EDUCATION="GET_EDUCATION";
/*User Project Education END*/

/* LOADING ACTION START */
export const LOADER_START = "LOADER_START";
export const LOADER_STOP = "LOADER_STOP";
/* LOADING ACTION END */

/* Alert Action Start */
export const ALERT_SUCCESS = 'ALERT_SUCCESS';
export const ALERT_ERROR = "ALERT_ERROR";
export const ALERT_CLEAR = "ALERT_CLEAR";
/* Alert Action End */

/* User Auth Start */

export const REGISTER_REQUEST= 'USERS_REGISTER_REQUEST';
export const REGISTER_SUCCESS= 'USERS_REGISTER_SUCCESS';
export const REGISTER_FAILURE= 'USERS_REGISTER_FAILURE';

export const LOGIN_REQUEST= 'USERS_LOGIN_REQUEST';
export const LOGIN_SUCCESS= 'USERS_LOGIN_SUCCESS';
export const LOGIN_FAILURE= 'USERS_LOGIN_FAILURE';

export const LOGOUT='USERS_LOGOUT';

export const GETALL_REQUEST= 'USERS_GETALL_REQUEST';
export const GETALL_SUCCESS= 'USERS_GETALL_SUCCESS';
export const GETALL_FAILURE= 'USERS_GETALL_FAILURE';

export const DELETE_REQUEST= 'USERS_DELETE_REQUEST';
export const DELETE_SUCCESS= 'USERS_DELETE_SUCCESS';
export const DELETE_FAILURE= 'USERS_DELETE_FAILURE';

export const SHOW_PARENTAL_SUCCESS="SHOW_PARENTAL_SUCCESS";
export const SHOW_PARENTAL_RESEND_EMAIL="SHOW_PARENTAL_RESEND_EMAIL";
export const SHOW_MOBILE_VERIFIED="SHOW_MOBILE_VERIFIED";
export const RESEND_OTP="RESEND_OTP";
export const SET_DEFAULT="SET_DEFAULT";

/* User Auth END */

/* User Projects Start */
export const GET_ALL_PROJECTDATA="GET_USER_PROJECTS";
export const DELETE_PROJECT="PROJECT_DELETE_REQUEST";
export const SHOW_ALL_PROJECTS="SHOW_ALL_PROJECTS";
export const SEARCH_PROJECTS="SEARCH_PROJECTS";
export const SORT_PROJECTS="SORT_PROJECTS";
export const REFRENCE_DATA="REFRENCE_DATA";
export const CREATE_PROJECT="CREATE_PROJECT";
export const GET_ALL_DATA="GET_ALL_DATA";
export const GET_ALL_EDIT_DATA="GET_ALL_EDIT_DATA";
export const VIEW_PROJECT="VIEW_PROJECT";
export const GET_PORTFOLIO="GET_PORTFOLIO";
/* User Projects END */


/*User Project EXPERIENCE Start*/
export const ADD_EXPERIENCE = "ADD_EXPERIENCE";
export const GET_EXPERIENCE = "GET_EXPERIENCE";
export const UPDATE_EXPERIENCE = "UPDATE_EXPERIENCE";
export const DELETE_EXPERIENCE = "DELETE_EXPERIENCE";
/*User Project EXPERIENCE END*/

/*User Courses Start*/
export const ADD_COURSES = "ADD_COURSES";
export const GET_COURSES = "GET_COURSES";
export const DELETE_COURSES = "DELETE_COURSES" 
/*User Course END*/

/*User ACCOMPLISHMENT Start*/
export const ADD_ACCOMPLISHMENT = "ADD_ACCOMPLISHMENT";
export const GET_ACCOMPLISHMENT = "GET_ACCOMPLISHMENT";
export const UPDATE_ACCOMPLISHMENT = "UPDATE_ACCOMPLISHMENT";
export const DELETE_ACCOMPLISHMENT = "DELETE_ACCOMPLISHMENT";
export const GET_SPORTACCOMPLISHMENT = "GET_SPORTACCOMPLISHMENT";
export const ADD_SPORTACCOMPLISHMENT = "ADD_SPORTACCOMPLISHMENT";
export const UPDATE_SPORTACCOMPLISHMENT = "UPDATE_SPORTACCOMPLISHMENT";
export const DELETE_SPORTACCOMPLISHMENT = "DELETE_SPORTACCOMPLISHMENT";
/*User ACCOMPLISHMENT END*/


/*User Badges Start*/
export const ADD_BADGES = "ADD_BADGES";
export const GET_BADGES = "GET_BADGES";
export const UPDATE_BADGES = "UPDATE_BADGES";
export const DELETE_BADGES = "DELETE_BADGES";
/*User Badges END*/

/*User Badges Start*/
export const ADD_HOBBIES = "ADD_HOBBIES";
export const GET_HOBBIES = "GET_HOBBIES";
export const ADD_MORE="ADD_MORE";
/*User Badges END*/

/*User MEMBERSHIP Start*/
export const ADD_MEMBERSHIP = "ADD_MEMBERSHIP";
export const GET_MEMBERSHIP = "GET_MEMBERSHIP";
export const UPDATE_MEMBERSHIP = "UPDATE_MEMBERSHIP";
export const DELETE_MEMBERSHIP = "DELETE_MEMBERSHIP";

/*User MEMBERSHIP END*/
/* User Auth Start */

/* CV ACTION */
export const TOTAL_CV_DATA= 'TOTAL_CV_DATA';
export const SEARCH_DATA= 'SEARCH_DATA';
export const GRADE_LIST= 'GRADE_LIST';
export const USER_DATA= 'USER_DATA';
export const SET_USER_DATA= 'SET_USER_DATA';
export const GET_EDUCATION_DATA= 'GET_EDUCATION_DATA';
export const GET_WORK= 'GET_WORK';
export const COURSE_DATA= 'COURSE_DATA';
export const PROJECT_DATA= 'PROJECT_DATA';
export const HOBBIES= 'HOBBIES';
export const GET_ALL_ACCOMPLISHMENT_DATA= 'GET_ALL_ACCOMPLISHMENT_DATA';
export const GET_SPORT_ACCOMPLISHMENT_DATA= 'GET_SPORT_ACCOMPLISHMENT_DATA';
export const GET_BADGES_DATA= 'GET_BADGES_DATA';
export const GET_SKILL_DATA= 'GET_SKILL_DATA';
export const SETWORK_EXPERIENCEDATA= 'SETWORK_EXPERIENCEDATA';
export const SET_COURSES= 'SET_COURSES';
export const SET_COURSES_PROJECT= 'SET_COURSES_PROJECT';
export const SET_HOBBIES= 'SET_HOBBIES';
export const SET_ACCOMPLISHMENTS = 'SET_ACCOMPLISHMENTS';
export const SET_SPORTS_ACCOMPLISHMENTS = 'SET_SPORTS_ACCOMPLISHMENTS';
export const SET_BADGE_DATA = 'SET_BADGE_DATA';
export const SET_MEMBERSHIP = 'SET_MEMBERSHIP';
export const SET_SKILL_DATA = 'SET_SKILL_DATA';
export const SET_SHOW_HOBBIES_RESTRICATION = 'SET_SHOW_HOBBIES_RESTRICATION';

// ADD



/* CV ACTION */
export const FINAL_REGISTER_REQUEST= 'FINAL_USERS_REGISTER_REQUEST';
export const FINAL_REGISTER_SUCCESS= 'FINAL_USERS_REGISTER_SUCCESS';
export const FINAL_REGISTER_FAILURE= 'FINAL_USERS_REGISTER_FAILURE';
export const SHOW_PARENTAL_SCREEN= 'SHOW_PARENTAL_SCREEN';
export const FINAL_REGISTER_COMPLETION= 'USERS_REGISTER_COMPLETION';

/* User Auth Start */

/*PROFILE*/
export const PROFILE_VIEW='PROFILE_VIEW';

/*SETTING*/
export const PASSWORD_SUCCESS='PASSWORD_SUCCESS';
export const PASSWORD_FAILURE='PASSWORD_FAILURE';
export const PASSWORD_REQUEST='PASSWORD_REQUEST';
export const MOBILE_UPDATE_REQUEST='MOBILE_UPDATE_REQUEST';
export const SHOW_PARENTAL_RESEND_REQUEST='SHOW_PARENTAL_RESEND_REQUEST';

export const UPDATE_ACCOUNT_REQUEST ='UPDATE_ACCOUNT_REQUEST';
export const UPDATE_ACCOUNT_SUCCESS ='UPDATE_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT_FAILURE ='UPDATE_ACCOUNT_FAILURE';
export const TOST_MESSAGE='TOST_MESSAGE';
export const SELF_EMAIL_VERIFICATION="SELF_EMAIL_VERIFICATION";
export const REQUEST_SELF_EMAIL_VERIFICATION="REQUEST_SELF_EMAIL_VERIFICATION";

/* CONNECTIONS */
export const FIND_CONNECTIONS='FIND_CONNECTIONS';
export const ALL_USERACCESS='ALL_USERACCESS';
export const USER_SCHOOL_NAME='USER_SCHOOL_NAME';
export const All_CONNECTIONS='All_CONNECTIONS';
export const RECEIVED_CONNECTIONS='RECEIVED_CONNECTIONS';
export const SENT_CONNECTIONS='SENT_CONNECTIONS';
export const FRIENDS_CONNECTIONS='FRIENDS_CONNECTIONS';
/* CONNECTIONS */

/* POSTS */
export const ALL_POSTS='ALL_POSTS';
export const ALL_MY_DIARY='ALL_MY_DIARY';
export const ADD_POST='ADD_POST';
export const EDIT_POST='EDIT_POST';
export const DELETE_POST='DELETE_POST';
export const POST_DETAILS='POST_DETAILS';
export const DIARY_DETAILS='DIARY_DETAILS';
export const ALL_FEEDS='ALL_FEEDS';
export const ADD_REPOST='ADD_REPOST';


/* POSTS */
/* MyStuff */
export const MYSTUFF_PROJECT_GUIDENCE='MYSTUFF_PROJECT_GUIDENCE';
export const MYSTUFF_PROJECT_MEMBER='MYSTUFF_PROJECT_MEMBER';
/* MyStuff */

/* Notifications */
export const All_NOTIFICATIONS='All_NOTIFICATIONS';
/* Notifications */

/* Interests */
export const All_INTERESTS='All_INTERESTS';
export const USER_INTERESTS='USER_INTERESTS';
export const USER_SUBINTERESTS='USER_SUBINTERESTS';
/* Interests */